import React, {Component} from 'react'
import ReactTable from 'react-table'
import {Query} from 'react-apollo'
import PropTypes from 'prop-types'
import 'react-table/react-table.css'

import QUERY from '../../../queries/reports/office_hours_worked'

class HWTable extends Component{

    render(){
        return (<ReactTable
            data={this.props.data}
            loading={this.props.loading}
            style={{display: 'flex', flex: 1, fontSize: '14px'}}
            columns={[
                {
                    Header: "Project ID",
                    id: 'project_id',
                    accessor: d => `${d.project_id}`,
                    filterable: true,
                    filterMethod: (filter, row) => {
                        if(!filter.value) return true

                        return row.project_id.toLowerCase().includes(filter.value.toLowerCase())
                    },
                },
                {
                    Header: "Name",
                    id: 'name',
                    accessor: 'name',
                    filterable: true,
                    filterMethod: (filter, row) => {
                        if(!filter.value) return true

                        return row.name.toLowerCase().includes(filter.value.toLowerCase())
                    },
                },
                {
                    Header: "Office",
                    id: 'office',
                    accessor: 'office',
                    filterable: false,
                },
                {
                    Header: "Hours Worked",
                    id: 'hours_worked',
                    accessor: 'hours_worked',
                    filterable: false,
                    Footer: (
                        <span>
                          <strong>Grand Total:</strong>{" "}
                                {this.props.data.reduce((carry, row) => carry += row.hours_worked, 0)}hrs
                        </span>
                    )
                }

            ]}
            SubComponent={row => {

                console.log(`row: ${JSON.stringify(row)}`)

                return (
                    <div style={{ padding: "20px" }}>
                        <ReactTable
                            data={row.original.user_breakdown}
                            defaultPageSize={5}
                            columns={[

                                {
                                    Header: "User",
                                    id: 'user_name',
                                    accessor: 'user_name',
                                    filterable: true,

                                    filterMethod: (filter, filterRow) => {
                                        if(!filter.value) return true

                                        return filterRow.user_name.toLowerCase().includes(filter.value.toLowerCase())
                                    },
                                },
                                {
                                    Header: "Hours Worked",
                                    id: 'hours_worked',
                                    accessor: 'hours_worked',
                                    filterable: false
                                }

                            ]}
                            className="-striped -highlight"
                        />
                    </div>
                );
            }}
            className="-striped -highlight"

        />)
    }
}

export default class OfficeHoursWorkedTable extends Component{

    render(){

        const {month, year, office_id} = this.props

        return(<Query query={QUERY} variables={{office_id, month, year}} fetchPolicy="network-only">
            {(result) => {

                const data = (result.data && result.data.report_project_hours_worked_total) ? result.data.report_project_hours_worked_total: []

                return(
                    <HWTable loading={result.loading} data={data}/>

                )
            }}
        </Query>)
    }
}
